/** @jsxImportSource @emotion/react */
import contextLoadable from '@signal/core/contextFetch/Loadable'
import MenuServiceContext from '@signal/core/menuService/Context'
import { MultiAppMenuPanelPropsType } from './types'
import { LeftMenuNew } from '../LeftMenuNew'
import SkeletonNew from '../LeftMenuNew/Skeleton'

export default contextLoadable<MultiAppMenuPanelPropsType>({
  fetchContexts: [MenuServiceContext],
  Component: LeftMenuNew,
  Skeleton: SkeletonNew
})
